import React from 'react';
import styled from 'styled-components';
import StepJourneyTabs from './StepJourneyTabs';

const StepJourneyWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const StepsContainer: React.FC = () => {

  return (
    <StepJourneyWrapper>
      <StepJourneyTabs />
    </StepJourneyWrapper>
  );
};

export default StepsContainer;